/**
 * The per-file Remove / Undo toggle for a removal that is sent with the vendor's next
 * thread reply (see lib/replyRemoval.ts). Nothing is deleted on click.
 */
export function ReplyRemoveToggle({
  fileName,
  removing,
  onToggle,
  disabled = false,
}: {
  fileName: string;
  removing: boolean;
  onToggle: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={(e) => {
        // Rows that expand on click (DocumentTable) must not toggle too.
        e.stopPropagation();
        onToggle();
      }}
      aria-label={`${removing ? 'Keep' : 'Remove'} ${fileName}`}
      className="shrink-0 rounded-md border border-slate-300 bg-white px-2.5 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50 disabled:opacity-50"
    >
      {removing ? 'Undo' : 'Remove'}
    </button>
  );
}

/** The "Will be removed" caption under a toggled row's file name. */
export function WillBeRemovedNote() {
  return (
    <span className="block text-[11px] font-medium text-red-700">
      Will be removed when you send your reply
    </span>
  );
}
